(() => {
  'use strict';
  if (window.AvonticSelectionContinuity) return;
  const valid = value => Number.isSafeInteger(Number(value)) && Number(value) > 0 && Number(value) <= 100000;
  const packSize = handle => /teamready/.test(handle || '') ? /-5-packs/.test(handle) ? 5 : 3 : 1;
  const context = () => {
    const strip = document.querySelector('[data-av17-bulk]');
    const form = strip && document.getElementById(strip.dataset.formId);
    return {input:form?.elements.namedItem('quantity'),handle:strip?.dataset.productHandle || ''};
  };
  const quantity = target => {
    const {input,handle} = context();
    return valid(input?.value) ? Math.ceil(Number(input.value) * packSize(handle) / packSize(target || handle)) : 1;
  };
  const carry = (url, target) => {
    if (url.origin !== location.origin) return url;
    const {input} = context();
    if (valid(input?.value)) url.searchParams.set('av_setup_quantity',String(quantity(target)));
    const source = new URL(location.href);
    ['preview_theme_id','_fd','pb','country','currency','locale'].forEach(key => {if(source.searchParams.has(key)) url.searchParams.set(key,source.searchParams.get(key));});
    return url;
  };
  const incoming = new URLSearchParams(location.search).get('av_setup_quantity');
  let desired = valid(incoming) ? Number(incoming) : null;
  let applying = false;
  const seen = new WeakSet();
  const restore = () => {
    const {input} = context();
    if (!input || seen.has(input)) return;
    seen.add(input);
    if (!desired) return;
    const min = Number(input.min) || 1, step = Number(input.step) || 1;
    const value = Math.max(min, min + Math.ceil((desired-min)/step)*step);
    input.value = String(input.max ? Math.min(value,Number(input.max)) : value);
    applying = true;
    input.dispatchEvent(new Event('input',{bubbles:true}));
    input.dispatchEvent(new Event('change',{bubbles:true}));
    applying = false;
    desired = Number(input.value);
  };
  document.addEventListener('input',event => {const {input}=context();if(!applying && event.target === input && valid(input.value)) desired=Number(input.value);});
  document.addEventListener('click',event => {
    const link=event.target.closest?.('[data-av-gs-link], [data-av-bundle-product-link]');
    if(link?.href) {const url=new URL(link.href,location.origin);carry(url,url.pathname.split('/').pop());link.href=url.href;}
  },true);
  const start=()=>{restore();const root=document.getElementById('avontic-primary-product')||document.querySelector('[data-station-root]');if(root)new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1)))restore();}).observe(root,{childList:true,subtree:true});};
  ['product:rerender','shopify:section:load'].forEach(name=>document.addEventListener(name,restore));
  window.AvonticSelectionContinuity=Object.freeze({carry,quantity});
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start,{once:true}):start();
})();
